/* 🤖 this file was generated by svg-to-ts*/
export const iconSuccess: {
  name: 'success';
  data: string;
} = {
  name: 'success',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 2C4.691 2 2 4.691 2 8s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm3.707 3.293a.999.999 0 010 1.414l-3.51 3.509a1.85 1.85 0 01-1.32.548c-.5 0-.968-.194-1.32-.547L4.231 8.642a1 1 0 111.535-1.283l1.12 1.339 3.406-3.405a1 1 0 011.414 0z"/></svg>`,
};
